import React, { Component } from 'react'

export default class WorksPortaAperta extends Component {
    render() {
        return (
            <div class="modal" id="worksportaaperta" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;La porta è
        aperta&quot; </strong>(racconti): <em>Marsilio Editori, Venezia, 1994 .</em><br /><br />
                                Finalista al premio &quot;Chianti&quot; (Greve in
        Chianti) edizione '94-'95. </h5>
                           
                        </div>
                        <div class="modal-body p-4" id="result">



                            <div align="left">



                                <strong>ne hanno scritto:</strong> <br /><br />

                                Giuseppe Gallo, L'Unità, 20.6.<br />r>
Fulvio Panzeri, Avvenire, 28.5.94<br />
                                Giuseppe Amoroso, La Gazzetta del sud, 27.5.94<br />
                                Massimo Raffaeli, Il Manifesto, 28.7.94<br />
                                Renato Bertacchini, L'Indipendente, 28.6.94<br />
                                David Fiesoli, La Gazzetta di Parma, 1.11.94<br />
                                Alberto Faustini, L'Adige, 10.7.94<br />
                                Luigi Serravalli, L'Alto Adige, 31.5.94<br />
                                Giuliana Perco, La Cronaca a nord-est, 1.6.94<br />
                                Tiziano Pompei, L'Unione Sarda, 5.11.94<br />
                                Italo Bosetto, La Cronaca di Verona, 15.10.94<br />
                                Giancarlo Papi, Il Corriere di Rimini, 7.6.94<br />
                                Erica Schweizer, L'Adige, 3.9.94<br />
                                Cristina Nesi, Il Grande Vetro, settembre 94<br />

                            </div>


                            <div align="left">
                                <strong>Selezione Stampa</strong>

                                <table border="0" align="center" cellspacing="7">
                                    <tr>

                                        <td align="center" width="100%">L'Unità 20/6/1994 &quot;Tutti in Fuga
        Dalla Realtà&quot; di Giuseppe Gallo. (177k)</td><td><a href="rec\portaaperta-tuttiinfuga.zip"><img
                                            src="./img/rec/portaaperta-tuttiinfuga_small.jpg" alt="scarica in formato zip" width="248"
                                            height="288"></img></a>
                                        </td>
                                    </tr><tr>
                                        <td align="center" width="100%">Il Manifesto 28/7/1994
                                        &quot;Quarantenni, un Adolescenza di Secondo Grado&quot;
        di Massimo Raffaeli. (165k)</td><td><a href="rec\portaaperta-quarantenni.zip"><img
                                            src="./img/rec/portaaperta-quarantenni_small.jpg" alt="scarica in formato zip" width="160"
                                            height="260"></img></a>
                                        </td>
                                    </tr><tr>

                                        <td align="center" width="100%">Avvenire 28/5/1994 &quot;Tamburini,
        Scenari e Coppie Aperte&quot; di Fulvio Panzeri. (156k)</td><td><a href="rec\portaaperta-tamburiniscenari.zip"><img
                                            src="./img/rec/portaaperta-tamburiniscenari_small.jpg" alt="scarica in formato zip" width="337"
                                            height="178"></img></a>

                                        </td>
                                    </tr><tr>
                                        <td align="center" width="100%">La Gazzetta Del Sud 29/5/1994 &quot;La
        Porta E' Aperta&quot; di Giuseppe Amoroso. (177k)</td><td><a href="rec\portaaperta-laporta.zip"><img
                                            src="./img/rec/portaaperta-laporta_small.jpg" alt="scarica in formato zip" width="211"
                                            height="252"></img></a>
                                        </td>
                                    </tr>
                                </table>

                            </div>


                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                        </div>
                    </div>
                </div >
            </div >


        )
    }
}
